import { SvgIcon } from '@/components/SvgIcon';

/**
 * 全局注册自定义组件
 * @param app
 */
export function setupCustomComponents(app) {
  app.component(SvgIcon.name, SvgIcon);
}
